<template>
  <svg
    width="100"
    height="91.471268"
    viewBox="0 0 100 91.471268"
    fill="none"
    version="1.1"
    class="status-icon_img"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs id="defs1" />
    <path
      id="path2"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="m 65.042204,14.810947 c 0,5.063942 -2.581011,9.53436 -6.518536,12.205251 -2.422958,1.643486 -5.359425,2.605619 -8.523784,2.605619 -3.164359,0 -6.100207,-0.962133 -8.523165,-2.605619 C 37.539194,24.345307 34.958221,19.874889 34.958221,14.810947 34.958221,6.631089 41.692538,0 49.999884,0 c 8.307346,0 15.04232,6.631089 15.04232,14.810947 z m 3.051381,40.592935 H 89.27608 C 95.198579,55.403882 100,50.676051 100,44.844361 100,39.012013 95.198579,34.28484 89.27608,34.28484 H 10.724229 C 4.80146,34.28484 0,39.012013 0,44.844361 0,50.676051 4.80146,55.403882 10.724229,55.403882 H 31.906841 L 0.151824,91.471264 H 28.338043 L 49.999884,66.774641 71.662305,91.471264 h 28.185987 z"
      fill="#000000"
      opacity="0.5"
      fill-opacity="0.5"
      style="stroke-width: 0.634775"
    />
  </svg>
</template>

<script>
  export default {
    name: 'IconKuper',
  }
</script>
